import ItemTableBody from "./ItemTableBody";
import GstTableHeader from "../common/GstTableHeader";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { ItemsDataType } from "../../../redux/gstModule/gstModuleTypes";

type AppProps = {
  itemData: ItemsDataType[];
  itemHeader: TableHeadersType[];
  type?: string;
};

const ItemDataTable = ({ itemData, itemHeader }: AppProps) => {
  return (
    <div className="gstr">
      <table className="table table-bordered table-responsive">
        <thead className="thead-light">
          <GstTableHeader tableHeader={itemHeader} />
        </thead>
        <tbody>
          <ItemTableBody data={itemData} tableHeader={itemHeader} />
        </tbody>
      </table>
    </div>
  );
};

export default ItemDataTable;
